import React, { ReactNode } from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react/dist';

interface IPageHeaderProps {
  children: ReactNode;
}

export default function PageHeader({
  children,
}: IPageHeaderProps): JSX.Element {
  return (
    <Stack y="md" as="header" marginTop="4">
      {children}
    </Stack>
  );
}
